import { paymentSubscriptionService } from "@/features/protest/services";
type ProceedToPaymentParams = {
  amount: number;
  useWallet: boolean;
  userId: string | number;
  propertyId: string;
  year?: number;
  /** Promo code applied on the client, or "" */
  couponCode?: string;
};

export const handleProceedToPayment = async ({
  amount,
  useWallet,
  userId,
  propertyId,
  year = 2026,
  couponCode = "",
}: ProceedToPaymentParams) => {
  const intentResponse = await paymentSubscriptionService.createPaymentIntent({
    user_id: userId,
    property_id: propertyId,
    year,
    amount,
    currency: "usd",
    use_wallet: useWallet,
    coupon_code: couponCode.trim(),
  });

  const payload = intentResponse.data;
  const paymentData = payload?.data;
  const clientSecret = paymentData?.client_secret || payload?.client_secret;

  if (!clientSecret) {
    throw new Error(
      payload?.message || intentResponse.message || "Failed to create payment intent"
    );
  }

  return paymentData || payload;
};

export type ProceedToMultiPaymentParams = {
  amount: number;
  priceId: string;
  propertyIds: string[];
  userId: string | number | null;
  year?: number;
  useWallet: boolean;
  couponCode?: string;
};

export const handleProceedToMultiPayment = async ({
  // amount,
  priceId,
  propertyIds,
  userId,
  year = 2026,
  useWallet,
  couponCode = "",
}: ProceedToMultiPaymentParams) => {
  const intentResponse = await paymentSubscriptionService.createMultiPaymentIntent({
    // amount,
    currency: "usd",
    price_id: priceId,
    property_ids: propertyIds,
    user_id: userId,
    year,
    use_wallet: useWallet,
    coupon_code: couponCode.trim(),
    success_url: `${window.location.origin}/payment/success?session_id={CHECKOUT_SESSION_ID}`,
    cancel_url: `${window.location.origin}/protest-payment`,
  });

  const payload = intentResponse.data as Record<string, unknown> | undefined;
  const paymentData = (payload?.data || payload || intentResponse) as Record<string, unknown>;

  const checkoutUrl = (paymentData?.checkout_url ||
    payload?.checkout_url ||
    (intentResponse as unknown as Record<string, unknown>)?.checkout_url) as string | undefined;

  if (checkoutUrl) {
    window.location.href = checkoutUrl;
    return paymentData;
  }

  const clientSecret = (paymentData?.client_secret || payload?.client_secret) as string | undefined;

  if (!clientSecret && !checkoutUrl) {
    throw new Error(
      (payload?.message as string) ||
        intentResponse.message ||
        "Failed to create multi-payment intent"
    );
  }

  return paymentData;
};
